import { defineStore } from "pinia";
import { onScopeDispose, shallowRef } from "vue";

import { DraftBulkAction } from "@/components/bulk-actions/types";

export const useStore = defineStore("new-bulk-actions", () => {
  const draft = shallowRef<DraftBulkAction>();

  const closeListeners: (() => void)[] = [];
  const doneListeners: (() => void)[] = [];

  return {
    setDraft: (next: DraftBulkAction) => {
      draft.value = next;
    },

    _draft: draft,
    _closeWatchers: closeListeners,
    _doneWatchers: doneListeners,
  };
});

export const onBulkActionCancel = (listener: () => void) => {
  const store = useStore();

  onScopeDispose(() => {
    store._closeWatchers = store._closeWatchers.filter((fn) => fn !== listener);
  });

  store._closeWatchers.push(listener);
};

export const onBulkActionSuccess = (listener: () => void) => {
  const store = useStore();

  onScopeDispose(() => {
    store._doneWatchers = store._doneWatchers.filter((fn) => fn !== listener);
  });

  store._doneWatchers.push(listener);
};
